import {NgModule} from '@angular/core';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {APP_DATE_FORMATS, APP_DATE_LOCALE} from 'src/app/shared/datetime-formats';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatLuxonDateModule} from '@angular/material-luxon-adapter';
import {MatTimepickerModule} from '@angular/material/timepicker';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DragDropModule} from '@angular/cdk/drag-drop';

@NgModule({
  imports: [
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatTimepickerModule,
    DragDropModule,
    MatLuxonDateModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatSliderModule,
    MatSortModule,
  ],
  exports: [
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatTimepickerModule,
    DragDropModule,
    MatLuxonDateModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatSliderModule,
    MatSortModule,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: APP_DATE_LOCALE},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
  ],
})
export class SharedUiMaterialModule {}
